import { gradientConfigs } from "app/components/static-charts/homepage/configs";
import PropTypes from "prop-types";
import { Doughnut } from "react-chartjs-2";

export const MessagingOpenRateChart = ({ innerText = "98" }) => {
  const data = {
    datasets: [
      {
        data: [98, 2],
        borderColor: "#00000000",
        ...gradientConfigs,
      },
    ],
  };
  const options = {
    animation: {
      duration: 3000, // 3 seconds
    },
    cutout: "90%",
    responsive: true,
    tooltips: {
      enabled: false,
    },
    hover: {
      mode: null,
    },
    elements: {},
    plugins: {
      legend: {
        display: false,
      },
    },
  };
  return (
    <div className="relative">
      <div
        className="z-2 absolute flex h-full w-full flex-row items-center 
        justify-center"
      >
        <label
          className="text-[36px] font-extrabold leading-[45px] text-white 
          md:text-[45px]"
        >
          {innerText}
          <span className="font-normal">%</span>
        </label>
      </div>
      <div className="z-1 relative">
        <Doughnut data={data} options={options} />
      </div>
    </div>
  );
};

MessagingOpenRateChart.propTypes = {
  innerText: PropTypes.string,
};
